export function getUserLang(): string {
  if (typeof window !== 'undefined' && window.navigator) {
    const lang =
      window.navigator.language?.slice(0, 2) ||
      window.navigator.languages?.[0]?.slice(0, 2) ||
      'en';
    return lang === 'pt' ? 'pt-br' : lang;
  }
  return 'en';
}

export function get404Content(content404: Record<string, any>): any {
  const userLang = getUserLang();
  return content404?.[userLang]?.data?.content || content404?.['en']?.data?.content || null;
}

export function shouldUpdateLangPath(path: string, lang: string): boolean {
  const firstSegment = path.split('/')[0];
  return firstSegment !== lang;
}

export function getLangPrefixedPath(path: string, lang: string): string {
  if (lang === 'en') {
    return `/${path.startsWith('/') ? path.slice(1) : path}`;
  }
  return `/${lang}/${path.startsWith('/') ? path.slice(1) : path}`;
}

export function is404Page(content: any): boolean {
  return !content || content.id === '5';
}
